import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useAuthStore } from './features/auth/store';
import { AppRoutes } from './routes';
import { createQueryClient } from './shared/data/queryClient';

export function App() {
  const queryClient = useMemo(() => createQueryClient(), []);
  const bootstrap = useAuthStore((s) => s.bootstrap);

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </QueryClientProvider>
  );
}
